import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../config";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const email = localStorage.getItem("resetEmail");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (newPassword !== confirmPassword) {
        toast.error("Passwords do not match");
        setIsLoading(false);
        return;
      }

      if (newPassword.length < 8) {
        toast.error("Password must be at least 8 characters long");
        setIsLoading(false);
        return;
      }

      const response = await axios.post(`${API_URL}/auth/reset-password`, {
        new_password: newPassword,
        confirm_password: confirmPassword,
        email,
      });

      toast.success("Password reset successfully");
      setTimeout(() => navigate("/"), 2000);
    } catch (error) {
      toast.error("Failed to reset password");
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1F9BFF1A] flex">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="w-full md:w-1/2 flex items-center justify-center">
        <div className="max-w-lg w-full space-y-8 bg-white p-6 md:p-14 rounded-2xl shadow-lg border border-gray-200 m-4 md:m-6 min-h-[550px] flex flex-col justify-center relative">
          <button
            onClick={() => navigate("/")}
            className="absolute top-6 left-6 text-gray-600 hover:text-gray-800 text-xl"
          >
            &#8592;
          </button>
          <div className="flex flex-col items-center justify-center p-4 md:p-8">
            <div className="self-start">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                Reset Password
              </h2>
              <p className="text-sm text-gray-600">
                Set the new password for your account
              </p>
            </div>
            <form
              onSubmit={handleResetPassword}
              className="mt-8 space-y-6 w-full"
            >
              <div>
                <label
                  htmlFor="newPassword"
                  className="block text-sm font-medium text-gray-500"
                >
                  New Password
                </label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  className="block w-full py-0.6 border-b border-gray-300 focus:border-b-2 focus:border-blue-500 focus:outline-none"
                />
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm font-medium text-gray-500 mt-4"
                >
                  Confirm Password
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="block w-full py-0.6 border-b border-gray-300 focus:border-b-2 focus:border-blue-500 focus:outline-none"
                />
              </div>
              <button
                type="submit"
                className="w-full py-2 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#1F9BFF] hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin h-5 w-5 mr-2 border-2 border-white border-t-transparent rounded-full"></div>
                    Resetting...
                  </div>
                ) : (
                  "Reset Password"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="hidden md:flex w-3/5 bg-[#1F9BFF1A] flex-col items-center justify-center p-12 text-white">
        <div className="flex items-center justify-center w-full h-full">
          <img
            src="/Group.png"
            alt="Group"
            className="w-4/5 max-w-lg object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
